import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/v2/ui/accordion";

const defaultFaqs = [
  {
    q: "What services does BookMyPooja offer?",
    a: "BookMyPooja, started in 2021, offers hassle free and reliable Pandits for puja arrangements services. Priests of your cultures get allocated for your puja rituals after booking. Entire process is efficiently managed for best puja benefits."
  },
  {
    q: "Who started BookMyPooja?",
    a: "Mr Dayanand Kamble is the founder of BookMyPooja. He is an experienced astrologer and author of the upcoming Book “Altar Ego - Ancient Vedic Rituals for Modern Souls”. He is an IIM Bangalore Alumnus who has more than 20 years of experience in corporate life as well."
  },
  {
    q: "Is it reliable to book online through the Insta Book method?",
    a: "Absolutely! Our Insta Book method is 100% reliable. Our dedicated Seva Team of expert priests and astrologers works behind the scenes from 8 AM to 9 PM every day. The moment your booking is received, they begin allocating a qualified pandit and share all necessary details with you promptly. Not a single puja has been missed or delayed out of the 10,000+ ceremonies we have facilitated so far. You can also track your booking status in real time — giving you complete peace of mind from the moment you book."
  },
  {
    q: "Will I definitely get the Panditji of my preferred language?",
    a: "We have a wide network of verified Vedic priests, so you will definitely get a pandit of your preferred language. However, for festive dates, we advise checking in advance with our team to ensure availability."
  },
  {
    q: "Do I need to pay in advance?",
    a: "Based on the package you choose, you can either pay the full amount upfront or pay a partial advance to confirm your booking (if booked through the Insta Book method). If you choose partial payment, the remaining balance is to be paid after the puja is completed by logging into the platform."
  },
  {
    q: "When do I get to know about the allocated Pandit Ji?",
    a: "After the puja is booked, within 24–48 hours. If the puja is within 24–48 hours itself, it will be allocated on priority — not to worry."
  },
  {
    q: "Are the packages including Dakshina?",
    a: "Yes, every package includes Dakshina, travel charges, and puja items as a bare minimum. Larger packages may account for fruits, flowers, additional priests, additional days of rituals, or more mantras."
  },
  {
    q: "Can I pay the balance amount to Pandit Ji directly?",
    a: "As a technology-first platform committed to financial transparency, all Dakshina and payments are processed through BookMyPooja. After the puja is successfully completed, the pandit's Dakshina is transferred directly to their bank account from BookMyPooja. You are not expected to pay the pandit directly — this ensures clarity and avoids any miscommunication."
  },
  {
    q: "Can I reschedule my booking?",
    a: "Please refer to our Terms & Conditions for rescheduling policies."
  },
  {
    q: "Can I book for someone else?",
    a: "Absolutely! You can book a puja for family or friends. Just provide their details during booking and we'll coordinate directly with them."
  },
  {
    q: "I have put an enquiry — how does the booking happen after that?",
    a: "Once you submit an enquiry, our Seva Team of expert pandits and astrologers will get in touch with you to understand your requirements. They will guide you on the puja to be performed, its duration, auspicious dates and times, and the most suitable package and costs. After the consultation, you can either book through the Insta Book method or work with the team to create a custom package tailored to your needs."
  },
  {
    q: "How does custom booking work?",
    a: "If the puja you need is not available as a standard Insta Book package, our team will create a custom booking for you. They will collect essential details — your name, email, phone number, Google Maps location, priest language preference, and chosen package. A payment link from our partner Razorpay will be shared for you to complete a 50% advance payment to confirm the booking. Once received, the booking is confirmed and pandit allocation begins within 24–48 hours. After the puja is completed, the remaining balance is payable through the same payment link. Please note — you are not expected to pay the pandit directly, as their Dakshina is transferred from BookMyPooja to their bank account after the puja."
  },
  {
    q: "How do you verify Pandits registered on your platform?",
    a: "Every pandit on BookMyPooja goes through a rigorous multi-step verification process. We check their Vedic education certificates from recognized Pathshalas, assess language proficiencies, review their experience conducting specific rituals, verify the number of years of active practice, and conduct reference checks with previous yajmaans (hosts). We also evaluate their knowledge of regional customs and rituals. Only pandits who clear all stages are onboarded, ensuring you receive a qualified and trustworthy priest every time."
  },
  {
    q: "If Pandit Dakshina is included in the package, how does the Pandit get paid?",
    a: "Our pandits' bank accounts are linked directly with the BookMyPooja platform. Once the puja is successfully completed and confirmed, the Dakshina amount is released to the pandit's account electronically. This ensures timely, transparent, and hassle-free payments for every priest."
  },
  {
    q: "Do I need to pay anything extra to the Pandit?",
    a: "No, you do not need to pay anything extra. All our pandits are trained and briefed not to ask for any additional payments beyond what is included in your package. If you choose to offer something voluntarily as a gesture of goodwill, that is entirely your personal choice — BookMyPooja does not get involved in or have any say over voluntary offerings."
  },
  {
    q: "What if I don't get a pandit of my preferred language?",
    a: "In over 90% of bookings, we successfully match your preferred language. However, during festive seasons or peak demand periods, scheduling conflicts may occasionally arise. In such cases, we reserve the right to allocate a pandit of a different language preference to ensure your puja is conducted on time."
  },
  {
    q: "Your team assigned a different language Pandit Ji. Will it affect my puja experience?",
    a: "Not at all. Assigning a pandit of a different linguistic background happens only about 10% of the time and is quite rare. In Vedic tradition, all puja steps, rituals, and mantras are performed in Sanskrit following established scriptural procedures. Language preference helps you feel closer to your mother tongue, but it does not impact the spiritual benefits or effectiveness of the puja in any way."
  },
  {
    q: "Cancellation and Refund",
    a: null, // handled with custom render
  },
];
const FAQSection = ({ items: cmsFaqs }) => {
  const displayFaqs = (cmsFaqs?.length > 0 ? cmsFaqs : defaultFaqs);

  return (
    <section id="faq" className="py-10 md:py-16 bg-card">
      <div className="container mx-auto max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-3">
          Frequently Asked <span className="text-primary">Questions</span>
        </h2>
        <p className="text-center text-muted-foreground text-lg mb-10">
          Everything you need to know before booking
        </p>
        <Accordion type="single" collapsible className="space-y-3">
          {displayFaqs.map((faq, i) => {
            const question = faq.q || faq.q;
            const answer = faq.a || faq.a;
            return (
              <AccordionItem key={i} value={`faq-${i}`} className="rounded-xl border bg-background px-5">
                <AccordionTrigger className="text-left font-sans font-semibold text-base hover:no-underline">
                  {question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {answer ? (
                    answer
                  ) : (
                    <span>
                      Our cancellation and refund policies are detailed in our Terms & Conditions. Please refer to them here:{" "}
                      <a
                        href="/terms-and-conditions"
                        className="text-primary underline hover:text-primary/80"
                      >
                        Terms & Conditions
                      </a>
                    </span>
                  )}
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
